export const PAY_CYCLE_MONTHLY = 'monthly';
export const PAY_CYCLE_SEMI_MONTHLY = 'semi_monthly';
export const PAY_CYCLE_BIWEEKLY = 'bi_weekly';
export const PAY_CYCLE_WEEKLY = 'weekly';

export enum PayCycleType {
    WEEKLY = PAY_CYCLE_WEEKLY,
    BI_WEEKLY = PAY_CYCLE_BIWEEKLY,
    SEMI_MONTHLY = PAY_CYCLE_SEMI_MONTHLY,
    MONTHLY = PAY_CYCLE_MONTHLY,
}

const PAY_CYCLE_TO_TEXT_MAP: { [key: string]: string } = {
    [PAY_CYCLE_WEEKLY]: 'weekly',
    [PAY_CYCLE_BIWEEKLY]: 'bi-weekly',
    [PAY_CYCLE_SEMI_MONTHLY]: 'semi-monthly',
    [PAY_CYCLE_MONTHLY]: 'monthly',
};

export const payCycleTypeToText = (payCycle: PayCycleType) =>
    PAY_CYCLE_TO_TEXT_MAP[payCycle];

export const payCycleOptions: { value: PayCycleType; label: string }[] = [
    {
        value: PayCycleType.WEEKLY,
        label: 'Weekly',
    },
    {
        value: PayCycleType.BI_WEEKLY,
        label: 'Bi-weekly',
    },
    {
        value: PayCycleType.MONTHLY,
        label: 'Monthly',
    },
];

export const yearlyPayCyclePeriods: Record<PayCycleType, number> = {
    [PayCycleType.WEEKLY]: 52,
    [PayCycleType.BI_WEEKLY]: 26,
    [PayCycleType.SEMI_MONTHLY]: 24,
    [PayCycleType.MONTHLY]: 12,
};
